import { dayjsTz } from '~/utils/dayjs';

export const formatReportTableDate = (dateString: string | number | null) => {
  if (!dateString) return 'None';

  const date = dayjsTz(dateString);
  const now = dayjsTz();
  const yesterday = dayjsTz().subtract(1, 'day');

  const isToday = date.format('YYYY-MM-DD') === now.format('YYYY-MM-DD');
  const isYesterday = date.format('YYYY-MM-DD') === yesterday.format('YYYY-MM-DD');

  if (isToday) {
    return `Today at ${date.format('HH:mm')}`;
  }

  if (isYesterday) {
    return `Yesterday at ${date.format('HH:mm')}`;
  }

  const daysDiff = now.diff(date, 'day');
  const isWithinWeek = daysDiff >= 0 && daysDiff < 7;

  if (isWithinWeek) {
    return `${date.format('dddd')} at ${date.format('HH:mm')}`;
  }

  return `${date.format('MMM D')} at ${date.format('hh:mm a')}`;
};
